import axios from "axios";
import env from "@/env";

const springAxiosInst = axios.create({
    baseURL: env.api.SPRING_API_URL,
    withCredentials: true
})

export default { springAxiosInst }